import { render } from "./CustomizationSaveButton.vue?vue&type=template&id=d9cb07dc"
import script from "./CustomizationSaveButton.vue?vue&type=script&lang=js"
export * from "./CustomizationSaveButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__